enum BookingTypes {
  RTM = 'rtm',
  Fixed = 'fixed',
  Queued = 'queued',
}

export type BookingType = keyof typeof BookingTypes

export default BookingTypes
